import { RICH_SECTION_BLOCK_NODE_TYPES } from "@repo/shared";

/**
 * Block nodes that carry a stable `blockId`.
 *
 * The Convex draft projection mints a `blockId` for every block of the shared
 * rich-section grammar (`ensureSanitizedBlockId`), and Claudia's granular block
 * operations address blocks by that id. The frontend must therefore recognise
 * exactly the same set: an unrecognised type has no `blockId` attribute in the
 * Tiptap schema, so ProseMirror drops the backend-provided id while parsing and
 * the persistence normalizer never restores it. `draft.get` and any of Claudia's
 * block-patching writes then each mint their own fresh random id independently,
 * and the write fails with `stale_block_ids` (LAT-938).
 *
 * `atomicField` is the one frontend-only addition: it is a top-level field node
 * rather than a rich-section child, and it anchors clarifications too.
 */
export const BLOCK_ID_NODE_TYPES = [...RICH_SECTION_BLOCK_NODE_TYPES, "atomicField"] as const;

export type BlockIdNodeType = (typeof BLOCK_ID_NODE_TYPES)[number];

export function isBlockIdNodeType(type: string): type is BlockIdNodeType {
  return (BLOCK_ID_NODE_TYPES as readonly string[]).includes(type);
}
